import { css, unsafeCSS } from 'lit';

const burstGlow = new URL('assets/burst-glow.svg', import.meta.url).href;
const shield = new URL('assets/shield.svg', import.meta.url).href;

export const style = css`
  .container {
    align-items: center;
    background-color: #10253f;
    display: flex;
    flex-direction: column;
    justify-items: center;
    padding-bottom: 32px;
    width: 100vw;

    @media (min-width: 768px) {
      justify-content: center;
      padding-bottom: 104px;
    }
  }

  .header {
    color: white;
    font-size: 32px;
    font-weight: 600;
    line-height: 42px;
    margin: 12px 48px;
    text-align: center;

    @media (min-width: 768px) {
      margin: 48px 48px 12px;
    }
  }

  .subheader {
    color: white;
    font-size: 20px;
    font-weight: 400;
    line-height: 30px;
    margin: 0 48px;
  }

  .glow {
    background-image: url(${unsafeCSS(burstGlow)});
    background-position: center center;
    background-repeat: no-repeat;
    height: 125px;
    margin-top: 24px;
    max-width: 500px;
    width: 100%;

    @media (min-width: 768px) {
      margin-top: 16px;
    }
  }

  .white-container {
    align-items: center;
    background-color: white;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    max-width: 500px;
    width: 100%;
  }

  .shield {
    background-image: url(${unsafeCSS(shield)});
    background-position: center center;
    background-repeat: no-repeat;
    height: 100px;
    position: relative;
    top: -32px;
    width: 100px;
  }

  .rate-container {
    align-items: stretch;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin: 0 32px 40px 32px;
    text-align: center;
    width: 310px;
  }

  .badge {
    margin-top: 6px;
  }

  .apr-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 4px;
    justify-content: center;
  }

  .apr-stack {
    display: flex;
    flex-direction: column;
  }

  .apr-number {
    font-size: 80px;
    font-weight: 600;
  }

  .apr-sign {
    font-size: 42px;
    font-weight: 600;
  }

  .apr-text {
    font-size: 16px;
    font-weight: 400;
  }
`;
